import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-count',
  templateUrl: './ticket-count.component.html',
  styleUrls: ['./ticket-count.component.css']
})
export class TicketCountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
